import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowLeft, History, ArrowRight as ArrowRightIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminDedupLogPage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!user || user.role !== "admin") return;
    api.get("/admin/dedupe-log?limit=500").then((r) => {
      setItems(r.data.items || []);
      setTotal(r.data.total || 0);
    });
  }, [user]);

  if (!user || user.role !== "admin") {
    return (
      <div className="container py-20 max-w-xl text-center" data-testid="admin-dedup-locked">
        <h1 className="display-2 mb-4">Admin only</h1>
      </div>
    );
  }

  return (
    <div className="container py-10 max-w-4xl">
      <Link to="/admin" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4" data-testid="admin-dedup-back">
        <ArrowLeft className="h-4 w-4" /> Back to Admin
      </Link>
      <p className="eyebrow mb-1 inline-flex items-center gap-2"><History className="h-3 w-3" /> Read-only audit</p>
      <h1 className="display-2 mb-2">{total.toLocaleString()} companies merged</h1>
      <p className="text-sm text-muted-foreground mb-6">
        Every entry below was a duplicate or India-variant that was collapsed into its canonical global identity. Jobs were re-pointed automatically. This page is read-only.
      </p>

      <div className="overflow-x-auto rounded-lg border border-border" data-testid="dedup-log-table">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs uppercase text-muted-foreground tracking-wider">
            <tr>
              <th className="py-2 px-3 text-left">Removed</th>
              <th className="py-2 px-3 text-left">Merged into</th>
              <th className="py-2 px-3 text-right">Jobs re-pointed</th>
              <th className="py-2 px-3 text-left">When</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {items.map((row) => (
              <tr key={row.removed_company_id} data-testid={`dedup-row-${row.removed_company_id}`}>
                <td className="py-2 px-3 text-muted-foreground line-through">{row.removed_name}</td>
                <td className="py-2 px-3 font-semibold inline-flex items-center gap-1.5">
                  <ArrowRightIcon className="h-3 w-3 text-primary" />
                  {row.merged_into_name}
                </td>
                <td className="py-2 px-3 text-right">{row.jobs_repointed || 0}</td>
                <td className="py-2 px-3 text-xs text-muted-foreground">{new Date(row.removed_at).toLocaleString()}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={4} className="py-10 text-center text-muted-foreground" data-testid="dedup-empty">No merges recorded yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
